import React, {useEffect, useRef} from 'react';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {StepImplementationProps, StepState} from '../../../../../types/checkoutApp.types';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {classes as commonClasses} from '../../../../../common/common.st.css';
import {DynamicStep, DynamicStepComponentProps} from '../../StepsManager/Components/DynamicStep';
import {StepHeader} from '../../StepsManager/Components/StepHeader';
import {DeliverySectionWrapper} from './Components/DeliveryMethodSection/DeliverySectionWrapper';

export enum DeliveryMethodStepDataHook {
  root = 'DeliveryMethodStep.root',
  header = 'DeliveryMethodStepDataHook.header',
  violations = 'DeliveryMethodStep.violations',
}

const InternalDeliveryMethodStep = ({index}: DynamicStepComponentProps) => {
  const localeKeys = useLocaleKeys();
  const {
    stepsManagerStore: {stepsList},
  } = useControllerProps();

  const stepState = stepsList[index].state;
  const sectionRootRef = useRef<HTMLDivElement>(null);

  const scrollToHeader = () => {
    sectionRootRef?.current?.scrollIntoView();
  };

  useEffect(
    () => {
      if (stepState === StepState.OPEN) {
        scrollToHeader();
      }
    },
    /* eslint-disable react-hooks/exhaustive-deps */ [stepState]
  );

  return (
    <>
      <StepHeader
        index={index}
        dataHook={DeliveryMethodStepDataHook.header}
        label={localeKeys.checkout.place_order_fast_flow.delivery_method_title()}
        ref={sectionRootRef}
      />
      <DeliverySectionWrapper stepState={stepState} />
    </>
  );
};

export const DeliveryMethodStep = ({index}: StepImplementationProps) => {
  return (
    <DynamicStep
      index={index!}
      dataHook={DeliveryMethodStepDataHook.root}
      component={InternalDeliveryMethodStep}
      className={commonClasses.oneColumnViewPadding}
    />
  );
};
